import DefaultLayout from './DefaultLayout';
import ProductViewLayout from './ProductViewLayout';
import ProductVariantsLayout from './ProductVariantsLayout';
import CartItemEditorLayout from './CartItemEditorLayout';
import HeadlessLayout from './HeadlessLayout';
export var layoutComponents = {
    DefaultLayout: DefaultLayout,
    HeadlessLayout: HeadlessLayout,
    ProductViewLayout: ProductViewLayout,
    ProductVariantsLayout: ProductVariantsLayout,
    CartItemEditorLayout: CartItemEditorLayout,
};
export var getLayoutComponent = function (name) {
    if (name && Object.prototype.hasOwnProperty.call(layoutComponents, name)) {
        return layoutComponents[name];
    }
    return layoutComponents['DefaultLayout'];
};
